(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const completeLookProducts = JSON.parse(this.dataset.completeLook || '[]');
    const DESIRED_PRODUCT_COUNT = 6;
    const excludedProducts = [...new Set([...completeLookProducts])];

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const recommendationProducts = Array.from(recommendations.querySelectorAll('.swiper-slide'));
            const filteredProducts = recommendationProducts.filter(product => {
              const productId = parseInt(product.querySelector('[data-product-id]')?.dataset.productId);
              return !(productId && excludedProducts.includes(productId));
            });

            const productsToShow = filteredProducts.slice(0, DESIRED_PRODUCT_COUNT);
            recommendationProducts.forEach(product => product.remove());

            const swiperWrapper = recommendations.querySelector('.swiper-wrapper');
            productsToShow.forEach(product => swiperWrapper.appendChild(product));

            this.innerHTML = recommendations.innerHTML;
          }

          if (typeof quickAddButton == 'function') quickAddButton();
          if (typeof initAtcBtnAddToCart == 'function') initAtcBtnAddToCart();
          if (typeof initSizeVariantAddToCart == 'function') initSizeVariantAddToCart();
          if (typeof initQuickView == 'function') initQuickView();
          if (typeof initQuickViewSizeSelection == 'function') initQuickViewSizeSelection();

          // Init Swiper
          document.querySelectorAll('.product-carousel').forEach(function(Element) {
            const outer = Element.closest('.carousel-rowouter');
            const nextBtn = outer.querySelector('.swiper-button-next');
            const prevBtn = outer.querySelector('.swiper-button-prev');
            new Swiper(Element, {
              loop: eval(Element.dataset.loop),
              slidesPerView: 'auto',
              navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
              },
            });
          });
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
